<script setup>
import {computed} from 'vue'
import {useAppStore} from '@/stores/appStore'

const appStore = useAppStore()

const ajaxRequestInProgress = computed(() => {
    return appStore.request?.ajaxRequestInProgress || false
})
</script>

<template>
    <div
        v-if="ajaxRequestInProgress"
        class="ajax-loader"
    />
</template>

<style scoped>
.ajax-loader {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
    animation: glowingLine 500ms infinite;
}

@keyframes glowingLine {
    0% {
        background-color: #fff;
    }
    50% {
        background-color: aqua;
    }
    100% {
        background-color: #fff;
    }
}
</style>